import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=dc939472&scoped=true&"
import script from "./BaseInput.vue?vue&type=script&lang=ts&"
export * from "./BaseInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=dc939472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc939472",
  null
  
)

export default component.exports